import Vue from 'vue'
import Vuex from 'vuex'
import { Toast } from 'vant';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    shoppingCart: [],
    machineInfo: { // 售货机信息
      facilityName: '',
      facilityNumber: '',
      facilityTel: ''
    },
    isCanPayByWeixin: false,
    code: '',
    openId: '',
    alipayCode: '',
    goodsNumLimit: 0,
    matchType: ''
  },
  getters: {
    shoppingCartNum(state) {
      let obj = {}
      state.shoppingCart.forEach((ev) => {
        obj[ev.id] = ev.num
      })
      return obj
    },
    goodsPriceTotal(state) {
      let numPrice = 0
      state.shoppingCart.forEach((ev) => {
        numPrice = ev.num * ev.price + numPrice
      })
      return numPrice.toFixed(2)
    },
    buyGoodsNum(state) {
      let num = 0
      state.shoppingCart.forEach((ev) => {
        num = num + ev.num
      })
      return num
    }
  },
  mutations: {
    setMatchType(state, v) {
      state.matchType = v
    },
    setGoodsNumLimit(state, v) {
      state.goodsNumLimit = v
    },
    setShoppingCart(state, obj) {
      let sum = 0
      state.shoppingCart.forEach((ev) => {
        sum = sum + ev.num
      })
      if (sum >= state.goodsNumLimit && state.matchType + '' === '1') {
        Toast('一次最多只能购买' + state.goodsNumLimit + '件商品')
        return
      }
      let mapId = state.shoppingCart.map((ev) => {
        return ev.trackId
      })
      //console.log('obj= ' + JSON.stringify(obj))
      //console.log('mapId= ' + JSON.stringify(mapId))
      if (mapId.includes(obj.trackId)) {
        state.shoppingCart.forEach((ev) => {
          if (ev.trackId === obj.trackId) {
            if (ev.num < ev.stock) {
              ev.num++
            } else {
              Toast('库存不足')
            }
          }
        })
      } else {
        if (obj.stock > 0) {
          obj.num = 1
          state.shoppingCart.push(obj)
        } else {
          Toast('库存不足')
        }
      }
    },
    reduceGoods(state, id) {
      state.shoppingCart.forEach((ev, i) => {
        if (ev.id === id) {
          ev.num--
          if (ev.num === 0) {
            state.shoppingCart.splice(i, 1)
          }
        }
      })
    },
    addGoods(state, id) {
      let sum = 0
      state.shoppingCart.forEach((ev) => {
        sum = sum + ev.num
      })
      if (sum >= state.goodsNumLimit && state.matchType + '' === '1') {
        Toast('一次最多只能购买' + state.goodsNumLimit + '件商品')
        return
      }
      state.shoppingCart.forEach((ev, i) => {
        if (ev.id === id) {
          if (ev.num < ev.stock) {
            ev.num++
          } else {
            Toast('库存不足')
          }
        }
      })
    },
    clearShoppingCart(state) {
      state.shoppingCart = []
    },
    setMachineInfo(state, v) {
      state.machineInfo = v
    },
    setIsCanPayByWeixin(state, v) {
      state.isCanPayByWeixin = v
    },
    setCode(state, v) {
      state.code = v
    },
    setOpenId(state, v) {
      state.openId = v
    },
    setAlipayCode(state, v) {
      state.alipayCode = v
    }
  },
  actions: {
  },
  modules: {
  }
})
